<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { Upload, Calendar, Smartphone, Zap } from 'lucide-vue-next'
import { useAuthStore } from '@/stores/auth'

const { t } = useI18n()
const router = useRouter()
const auth = useAuthStore()
</script>

<template>
    <section class="mb-6">
        <div class="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
            <div class="flex items-center gap-3 px-4 py-3 border-b border-gray-200">
                <div class="w-6 h-6 rounded-lg bg-teal/10 flex items-center justify-center">
                    <Zap class="w-3.5 h-3.5 text-teal" />
                </div>
                <span class="text-sm font-semibold text-ink">{{ t('dashboard.actions.title') }}</span>
            </div>
            <div class="p-3 flex flex-col gap-1">
                <button v-if="auth.hasRight('allowManageTickets')" type="button"
                    class="flex items-center gap-2 px-3 py-2 rounded-md hover:bg-teal/5 text-sm text-ink transition cursor-pointer"
                    @click="router.push('/tickets/import')">
                    <Upload class="w-4 h-4 text-teal" />
                    {{ t('dashboard.actions.importTickets') }}
                </button>
                <button v-if="auth.hasRight('allowManageEvents')" type="button"
                    class="flex items-center gap-2 px-3 py-2 rounded-md hover:bg-teal/5 text-sm text-ink transition cursor-pointer"
                    @click="router.push('/events?new=1')">
                    <Calendar class="w-4 h-4 text-teal" />
                    {{ t('dashboard.actions.newEvent') }}
                </button>
                <button v-if="auth.hasRight('allowManageDevices')" type="button"
                    class="flex items-center gap-2 px-3 py-2 rounded-md hover:bg-teal/5 text-sm text-ink transition cursor-pointer"
                    @click="router.push('/devices?new=1')">
                    <Smartphone class="w-4 h-4 text-teal" />
                    {{ t('dashboard.actions.newDevice') }}
                </button>
            </div>
        </div>
    </section>
</template>
